import React, { useState } from 'react';
import * as styles from '../CitationImportHistory.module.scss';
import { StatBox } from './StatBox';
import { CitationSourcesForm } from './CitationSourcesForm';
import {
  Text,
  Popover,
  PopoverTrigger,
  Icon,
  IconList,
  PopoverContent,
} from 'components/core';
import { CitationImportSource } from 'types';

type Props = {
  id: string;
  citations: number;
  reviewImportSources: string[];
  citationImportSources: CitationImportSource[];
  importSourcesPlaceholder: string;
};

export const SourcesStatBox = ({
  id,
  citations,
  reviewImportSources,
  citationImportSources,
  importSourcesPlaceholder,
}: Props) => {
  const [sourcesPopoverIsOpen, setSourcesPopoverIsOpen] = useState(false);
  const [
    storedCitationImportSources,
    setStoredCitationImportSources,
  ] = useState(citationImportSources);
  const [
    storedImportSourcesPlaceholderText,
    setStoredImportSourcesPlaceholderText,
  ] = useState(importSourcesPlaceholder);
  return (
    <Popover
      isOpen={sourcesPopoverIsOpen}
      renderCloseButton={false}
      closeOnEscape={false}
      placement="bottom-end"
    >
      <PopoverTrigger>
        <StatBox
          header={
            <span>
              <Text
                component="span"
                data-testid={`edit-citation-sources-${id}`}
              >
                Source <Icon icon={IconList.light.faPenToSquare} />
              </Text>
            </span>
          }
          value={<Text size="md">{storedImportSourcesPlaceholderText}</Text>}
          clickable
          parentClick={() => setSourcesPopoverIsOpen(!sourcesPopoverIsOpen)}
        />
      </PopoverTrigger>

      <PopoverContent
        aria-label="Citation sources"
        className={styles.CitationImportSourcesPopover_content}
      >
        <CitationSourcesForm
          citationImportSources={storedCitationImportSources}
          setStoredCitationImportSources={setStoredCitationImportSources}
          setStoredImportSourcesPlaceholderText={
            setStoredImportSourcesPlaceholderText
          }
          reviewImportSources={reviewImportSources}
          citationImportId={id}
          setSourcesPopoverIsOpen={setSourcesPopoverIsOpen}
          citationImportTotalCitations={citations}
        />
      </PopoverContent>
    </Popover>
  );
};
